import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../../response.js';
import { acceptJson, postJson, authHeader } from '../../shared.js';

function quantity(apiUrl, accessToken, customerId, subscriptionId, request) {
    return _quantity.apply(this, arguments);
}
function _quantity() {
    _quantity = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, customerId, subscriptionId, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/subscription/${subscriptionId}/quantity`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(request)
        })));
    });
    return _quantity.apply(this, arguments);
}

export { quantity };
//# sourceMappingURL=quantity.js.map
